module.exports = __webpack_public_path__ + "static/media/multi_blog_subscription.a3e58a71.png";